// Dữ liệu dùng chung cho cụm trang có sidebar nhân sự (Bảng tin, Lộ trình thăng tiến, Sơ đồ tổ chức, Quá trình làm việc).
// Chưa nối API: thông báo hệ thống là dữ liệu mẫu, trạng thái "đã đọc" lưu ở trình duyệt theo từng tài khoản.
import { useCallback, useEffect, useState } from 'react';

export const COMPANY_NAME = 'CÔNG TY CỔ PHẦN BUSO';

export interface SystemNotice {
  id: string;
  title: string;
  /** ISO */
  time: string;
  category: 'Nâng cấp' | 'Chính sách' | 'Bảo trì' | 'Hướng dẫn';
  /** Mỗi phần tử là một đoạn */
  content: string[];
}

export const SYSTEM_NOTICES: SystemNotice[] = [
  {
    id: 'n-2026-10-social', category: 'Nâng cấp', time: '2026-10-09T08:00:00+07:00',
    title: 'Bảng tin nội bộ: thêm nhắc tên (@), tìm kiếm và xem ai đã tương tác',
    content: [
      'Từ hôm nay, bạn có thể gõ @ để nhắc tên đồng nghiệp trong bài viết và bình luận. Bài nhắc đến bạn nằm ở mục “Nhắc đến tôi”.',
      'Ô tìm kiếm trên Bảng tin tìm theo nội dung, người đăng và bình luận, không cần gõ dấu.',
      'Bấm vào số cảm xúc hoặc lượt xem để biết ai đã tương tác với bài.',
    ],
  },
  {
    id: 'n-2026-09-upgrade', category: 'Nâng cấp', time: '2026-09-03T17:00:00+07:00',
    title: 'Thông báo định kỳ các tính năng nâng cấp tháng 9/2026',
    content: [
      'Dashboard kinh doanh gom Trực page, Telesale và Sale cơ sở trên một màn hình, có cảnh báo điểm nghẽn.',
      'Báo cáo Marketing bổ sung xuất Excel theo từng bộ phận.',
    ],
  },
  {
    id: 'n-2026-08-payroll', category: 'Nâng cấp', time: '2026-08-24T14:00:00+07:00',
    title: 'Nâng cấp bảng lương: xem chi tiết các khoản thu nhập',
    content: ['Bảng lương hiển thị chi tiết lương cơ bản, hoa hồng và phụ cấp theo tháng. Nếu có sai lệch, vui lòng phản hồi phòng Nhân sự trước ngày 05 hằng tháng.'],
  },
  {
    id: 'n-2026-08-tos', category: 'Chính sách', time: '2026-08-21T17:30:00+07:00',
    title: 'Cập nhật điều khoản sử dụng và cam kết bảo mật thông tin khách hàng',
    content: [
      'Nhân sự không chia sẻ số điện thoại, hình ảnh trước/sau của khách hàng ra ngoài hệ thống.',
      'Mọi thao tác xem, xuất dữ liệu khách hàng đều được ghi nhật ký.',
    ],
  },
  {
    id: 'n-2026-08-maint', category: 'Bảo trì', time: '2026-08-10T21:00:00+07:00',
    title: 'Bảo trì hệ thống 23:00 – 23:30 ngày 10/08/2026',
    content: ['Trong thời gian bảo trì, chức năng đặt lịch và chat với khách tạm ngưng. Dữ liệu không bị ảnh hưởng.'],
  },
  {
    id: 'n-2026-07-guide', category: 'Hướng dẫn', time: '2026-07-15T09:00:00+07:00',
    title: 'Hướng dẫn cập nhật trạng thái chăm sóc khách hàng đúng quy trình',
    content: ['Sau mỗi cuộc gọi, Telesale cập nhật kết quả gọi và giai đoạn khách (S0 – S8) để Dashboard tính đúng tỷ lệ chuyển đổi.'],
  },
];

export const NOTICE_CATEGORY_COLOR: Record<SystemNotice['category'], string> = {
  'Nâng cấp': 'blue', 'Chính sách': 'purple', 'Bảo trì': 'orange', 'Hướng dẫn': 'green',
};

const readKey = (meId: string) => `user_hub_notice_read_${meId}`;
const EVENT = 'user-hub-notice-read';

function loadRead(meId: string): string[] {
  try { const v = JSON.parse(localStorage.getItem(readKey(meId)) || '[]'); return Array.isArray(v) ? v : []; } catch { return []; }
}

/** Trạng thái đã đọc của thông báo hệ thống; đồng bộ giữa sidebar desktop / mobile và giữa các tab */
export function useNoticeReads(meId: string) {
  const [read, setRead] = useState<string[]>(() => loadRead(meId));
  useEffect(() => {
    const sync = () => setRead(loadRead(meId));
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener('storage', sync); };
  }, [meId]);
  const save = useCallback((ids: string[]) => {
    try { localStorage.setItem(readKey(meId), JSON.stringify(ids)); } catch { /* bỏ qua */ }
    window.dispatchEvent(new Event(EVENT));
  }, [meId]);
  const markRead = useCallback((id: string) => { const cur = loadRead(meId); if (!cur.includes(id)) save([...cur, id]); }, [meId, save]);
  const markAllRead = useCallback(() => save(SYSTEM_NOTICES.map(n => n.id)), [save]);
  const unread = SYSTEM_NOTICES.filter(n => !read.includes(n.id)).length;
  return { read, markRead, markAllRead, unread };
}
